export default "__VITE_ASSET__BF0w$9_H__"